import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "p-token-from",
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["web3Data", "userInfo"])
  },
  data() {
    return {
      imgCutterShow: false,
      upImgLoading: false,
      isBtnLoading: false,
      form: {
        tokenIcon: null,
        tokenIconX: null,
        tokenName: null,
        tokenSymbol: null,
        tokenDescription: null,
        tokenWebsite: null,
        tokenTwitter: null,
        tokenTelegram: null,
        initBuy: 0,
        check: false
      },
      vail: {
        tokenName: null,
        tokenSymbol: null,
        tokenTwitter: null,
        tokenTelegram: null,
        initBuy: null,
        check: null
      },
      initBuyInfo: null,
      popTermsShow: false
    };
  },
  watch: {
    "form.tokenIcon": {
      handler(val) {
        if (val) {
          this.upImgLoading = false;
        }
      }
    },
    netId: {
      handler(id) {
        console.log("id", id);
        if (id && !this.isWallet) {
          this.noWalletWeb3Init();
        }
      },
      deep: true,
      immediate: true
    },
    isWallet: {
      handler(newBool, oldBool) {
        if (!newBool) return;
        this.walletWeb3Init();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["launchToken", "upLoadImg", "getTokenInfo"]),
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapMutations(['setWeb3Data']),
    onShowTerms() {
      this.popTermsShow = true;
    },
    async noWalletWeb3Init() {
      await this.web3Wallet.web3BasicQueryFn();
    },
    async walletWeb3Init() {
      await this.noWalletWeb3Init();
    },
    initForm() {
      this.form = {
        tokenIcon: null,
        tokenIconX: null,
        tokenName: null,
        tokenSymbol: null,
        tokenDescription: null,
        tokenWebsite: null,
        tokenTwitter: null,
        tokenTelegram: null,
        initBuy: 0,
        check: false
      };
    },
    async cutDown(e) {
      if (e.requireUrl) {
        this.form.tokenIcon = e.requireUrl?.fullpath;
        this.form.tokenIconX = e.requireUrl?.path;
      } else {
        if (this.userInfo?.auth_token) {
          const rs = await this.upLoadImg(e.file);
          if (!rs) {
            this.isBtnLoading = false;
            return;
          }
          this.isBtnLoading = false;
          this.form.tokenIcon = rs.data.fullpath;
          this.form.tokenIconX = rs.data.path;
          this.vailForm("tokenIcon");
        } else {
          this.upImgLoading = false;
          this.doConnect();
        }
      }
    },
    onOpenImgCurrter() {
      this.$nextTick(() => {
        this.$refs.mImgCurrer?.handleOpen();
      });
    },
    calcTokenOut(tokenIn) {
      let ethAmount = Number(this.virtuALLaquidity); //配置的虚拟底池
      let tokenAmount = Number(this.tokenAmount); //配置的, 固定10亿
      let fee = Number(this.tokenFee); //手续费, 配置的
      let _tokenIn = Number(tokenIn);
      return tokenAmount - ethAmount * tokenAmount / (ethAmount + _tokenIn * (1 - fee));
    },
    vailForm(type) {
      let val = this.form[type] || "";
      this.vail[type] = null;
      switch (type) {
        case "tokenName":
          if (/^$/.test(val)) {
            this.vail[type] = this.$lang("Token Name is required");
          } else if (!/^.{1,64}$/.test(val)) {
            this.vail[type] = this.$lang("Token Name must be 64 characters or less");
          } else {
            this.vail[type] = false;
          }
          break;
        case "tokenSymbol":
          if (/^$/.test(val)) {
            this.vail[type] = this.$lang("Token Symbol is required");
          } else if (!/^.{1,8}$/.test(val)) {
            this.vail[type] = this.$lang("Token Symbol must be 8 characters or less");
          } else {
            this.vail[type] = false;
          }
          break;
        case "tokenTwitter":
          if (val && !/^(https?:\/\/)?(www\.)?(x\.com|twitter\.com)\/([a-zA-Z0-9_]{1,15})$/.test(val)) {
            this.vail[type] = this.$lang("Invalid URL");
          } else {
            this.vail[type] = false;
          }
          break;
        case "tokenTelegram":
          if (val && !/^(https?:\/\/)?(www\.)?t\.me\/[a-zA-Z0-9_]+(\/[a-zA-Z0-9_]+)*\/?$/.test(val)) {
            this.vail[type] = this.$lang("Invalid URL");
          } else {
            this.vail[type] = false;
          }
          break;
        case "initBuy":
          // const min = 0.0001;
          const max = Math.ceil(this.maxEther / (1 - this.web3Wallet.feeRate / 100));
          console.log("this.maxEther", max, this.web3Wallet.feeRate, this.maxEther, 1 - this.web3Wallet.feeRate / 100);
          const regex = /^(?!0\d)\d*(\.\d{0,4})?$/;
          if (!regex.test(this.form[type])) {
            this.form[type] = this.form[type].slice(0, -1);
          } else if (!/^(?!0(\\.0+)?$)(0(\\.[0-9]{1,2})?|([1-2]?\\d(\\.[0-9]{1,2})?|${min}(\\.[0-9]{1,2})?|${max}(\\.[0-9]{1,2})?))$/.test(Number(val))) {
            if (Number(val) > max) {
              this.vail[type] = `Amount not exceeding ${max} ${this.web3Wallet.symbol}`;
            } else {
              this.vail[type] = null;
              const calcTokenOut = this.calcTokenOut(this.form[type]);
              this.initBuyInfo = calcTokenOut;
            }
          } else {
            this.vail[type] = false;
          }
          break;
        case "check":
          if (!Boolean(val)) {
            this.vail[type] = this.$lang("Terms & Conditions not checked");
          } else {
            this.vail[type] = false;
          }
          break;
      }
    },
    onCheck() {
      this.form.check = !this.form.check;
      this.vailForm("check");
      console.log(this.web3Wallet);
    },
    async onLaunch() {
      const vailStatusList = Object.keys(this.vail).filter(key => !(key === "tokenTwitter" && !this.form.tokenTwitter) && !(key === "tokenTelegram" && !this.form.tokenTelegram)).map(key => {
        this.vailForm(key);
        return Boolean(this.vail[key]);
      });
      console.log("vailStatusList", vailStatusList);
      const isVail = vailStatusList.every(itm => !itm);
      console.log("isVail", isVail);
      //通过验证
      if (!isVail) return;
      if (this.isBtnLoading) return;
      this.isBtnLoading = true;
      let form = JSON.parse(JSON.stringify(this.form));
      let params = {
        name: form.tokenName,
        icon: form.tokenIconX,
        symbol: form.tokenSymbol,
        website: form.tokenWebsite,
        twitter: form.tokenTwitter,
        telegram: form.tokenTelegram,
        description: form.tokenDescription
      };
      console.log("params", params);
      const res = await this.launchToken(params);
      if (!res) {
        this.isBtnLoading = false;
        return;
      }
      try {
        const ref = this.userInfo.referral;
        const createFeeWei = this.web3Wallet.createFee.value;
        let initBuyWei = 0;
        if (this.form.initBuy !== 0) {
          initBuyWei = _v.fmt_floatDec(this.form.initBuy, "wei");
        }
        const pay = _v.fmt_floatDec(this.bigNumber(createFeeWei).plus(initBuyWei), "bigInt");
        if (this.web3Wallet.address) {
          const etherBalance = await this.web3Wallet.getBalance(this.web3Wallet.address);
          this.setWeb3Data({
            balance: etherBalance
          });
        }
        if (this.web3Data.balance) {
          const _initBuy = _v.fmt_floatDec(this.bigNumber(createFeeWei).plus(initBuyWei));
          if (this.bigNumber(_initBuy).gt(this.web3Data.balance.formatted)) {
            this.isBtnLoading = false;
            this.vail.initBuy = `Insufficient balance, At least ${_initBuy} ${this.web3Wallet.symbol}`;
            return;
          }
        }
        const tx = await this.web3Wallet.contract("marspump", "marsPumpAddr").send("create", [res.data["_name"], res.data["_symbol"], res.data["_id"], res.data["_expire"], ref, res.v, res.r, res.s], pay);
        const tokenAddr = tx.logs[0].address;
        let tokenInfo = null;
        const fn = async () => {
          tokenInfo = await this.getTokenInfo({
            token: tokenAddr
          });
          console.log("tokenInfo", tokenInfo);
          if (!tokenInfo || tokenInfo?.code === 10001) {
            setTimeout(fn, 3000);
            return;
          }
          this.initForm();
          this.isBtnLoading = false;
          this.$nextTick(() => {
            this.$router.push(`/token/${tokenAddr}`);
          });
        };
        fn();
      } catch (err) {
        console.log("err", err);
        this.isBtnLoading = false;
      }
    }
  }
};